__turbopack_context__.v({
  "animatedAgreementsWrapper": "jBQRMa_animatedAgreementsWrapper",
  "animatedAgreementsWrapperVisible": "jBQRMa_animatedAgreementsWrapperVisible",
  "blikInput": "jBQRMa_blikInput",
  "informationBoxText": "jBQRMa_informationBoxText",
  "informationBoxWrapper": "jBQRMa_informationBoxWrapper",
  "paymentImage": "jBQRMa_paymentImage",
  "paymentMethodSelectionWrapper": "jBQRMa_paymentMethodSelectionWrapper",
  "paymentText": "jBQRMa_paymentText",
  "paymentTitle": "jBQRMa_paymentTitle",
  "paymentWrapper": "jBQRMa_paymentWrapper",
  "statuteLabel": "jBQRMa_statuteLabel",
  "statuteWrapper": "jBQRMa_statuteWrapper",
  "statuteWrapperChecked": "jBQRMa_statuteWrapperChecked",
  "statuteWrapperLabel": "jBQRMa_statuteWrapperLabel",
  "subtitle": "jBQRMa_subtitle",
  "title": "jBQRMa_title",
  "wrapper": "jBQRMa_wrapper",
});
